<template>
  <div class="aside-box">
    <!-- <div class="aside-cont t-c c-p">
      <el-popover placement="top" :width="200" trigger="click" :transition="''">
        <template #reference>
          <div class="global-fab">
            <div class="img-box">
              <span class="icon blue-icon">{{ item.icon }}</span>
              <span class="icon white-icon">{{ item.icon }}</span>
            </div>
            <span class="text">{{ item.label }}</span>
          </div>
        </template>
        <div class="service-pop">
          <el-image style="width: 100px; height: 100px" :src="serviceUrl" v-if="serviceUrl">
          </el-image>
          <div class="empty-pop" v-else>
            <p style="text-align: center;">暂无客服</p>
          </div>
        </div>
      </el-popover>
    </div> -->

    <div class="global-fab-wrapper">
      <el-popover placement="top" :width="200" trigger="click" :transition="''">
        <template #reference>
          <div class="global-fab">
            <img src="@/assets/images/kf.png">
            <!-- <i class="el-icon-s-custom"></i> -->
          </div>
        </template>
        <div class="service-pop">
          <el-image style="width: 100px; height: 100px" :src="serviceUrl" v-if="serviceUrl">
          </el-image>
          <div class="empty-pop" v-else>
            <p style="text-align: center;">暂无客服</p>
          </div>
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>
import { api } from '@/api/api';

export default {
  name: 'SiteAside',
  data() {
    return {
      // items: [
      //   // { label: '咨询客服', icon: '💬' },
      //   // { label: '企业定制', icon: '🏢' },
      //   // { label: '报价方案', icon: '📋' },
      //   // { label: '申请试用', icon: '✨' }
      // ],
      serviceUrl: ''
    }
  },
  mounted() {
    this.fetchServiceUrl()
  },
  methods: {
    async fetchServiceUrl() {
      try {
        const response = await api.get('baoyan/customerService/getByServiceType/0', { serialNum: this.serialNum || this.order }, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        if (response.code === 200) {
          this.serviceUrl = response.data.serviceUrl || ''
          console.log('serviceUrl', this.serviceUrl)
        } else if (response.code === 500) {
          this.$message({ type: 'error', message: response.msg || '请求出错' })
        }
      } catch (err) {
        // console.log("err2", err)
        this.$message({ type: 'error', message: err.msg || '请求出错' })
      }

    },
    openService() {

    }
  }
}
</script>

<style lang="scss" scoped>
.aside-box {
  position: fixed;
  right: 30px;
  bottom: 134px;
  z-index: 999;
}

.aside-cont {
  border: 1px solid #ececec;
  border-bottom: 0;
  background-color: #fff;
  width: 72px;
  height: 72px;
  padding: 12px 0;
  transition: all 0.3s;

  &:last-child {
    border-bottom: 1px solid #ececec;
  }

  &:hover {
    background: linear-gradient(270deg, #49a1fa, #0067ff);
    border-color: transparent;

    .white-icon {
      display: block;
    }

    .blue-icon {
      display: none;
    }

    .text {
      color: #fff;
    }
  }

  .img-box {
    margin-bottom: 4px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon {
    font-size: 18px;
    line-height: 24px;
  }

  .white-icon {
    display: none;
  }

  .text {
    display: block;
    font-size: 12px;
    color: #666;
    line-height: 1.2;
    transform: scale(0.85);
  }
}

@media (max-width: 768px) {
  .aside-box {
    display: none;
  }
}


.global-fab-wrapper {
   width: 56px;
  height: 56px;
//  background-color: red;
  // z-index: 1000;
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.global-fab-wrapper:hover {
  transform: scale(1.1);
}

.global-fab {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: #409EFF;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.global-fab:hover {
  background-color: #66b1ff;
  box-shadow: 0 6px 20px rgba(64, 158, 255, 0.5);
}

.service-pop{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 200px;
}
</style>
